<ap-search
  #search
  [placeholder]="'dashboard.searchPlaceholder' | translate"
  [ngModel]="searchText()"
  (ngModelChange)="searchText.set($event)"
  [searchType]="'secondary'"
  [filtered]="isFullVariant()"
  [searchStatus]="
    showNoSearchResults()
      ? ('dashboard.searchNoResults' | translate)
      : showDeepSearchTrigger()
        ? ('dashboard.deepSearchTrigger' | translate)
        : ''
  "
  [list]="searchResults()"
  [noResultMsg]="
    showNoSearchResults() ? ('dashboard.searchNoResults' | translate) : ''
  "
  (onClear)="searchText.set('')"
  (keydown.enter)="onSearchKeydown()">
  @if (isFullVariant()) {
    @for (result of searchResults(); track result.route) {
      <ap-dropdown-list-item
        #dropdownListItem
        [item]="result"
        [highlightText]="searchText()"
        (onSelectItem)="navigateToResult(result.route)">
      </ap-dropdown-list-item>
    }

    @if (showDeepSearchTrigger()) {
      <button type="button" class="ap-option-item global-search-trigger">
        <span class="ap-typography-body">{{
          'dashboard.deepSearchTrigger' | translate
        }}</span>
        <span class="Appkit4-icon icon-arrow-increase-small-outline"></span>
      </button>
    }
  }
</ap-search>
